@if (config) {
  <div class="highlight">
    <div class="headers">
      <div class="header1">{{ metadata.label }}</div>
      @if (!isLatestSales) {
        <div class="header2">Guidance</div>
      }
      @if (isLatestSales && !showAmount) {
        <div class="header2">NACHA</div>
      }
    </div>
    <div class="chart" [ngClass]="{'latest-chart': isLatestSales}">
      @for (item of metadata.elements; track item) {
        <div class="element">
          <div class="concept">
            @if (isLatestSales) {
              <span class="dot" [style.background-color]="item.color"></span>
            }
            {{ item.description }}
          </div>
          <div class="chartAmount" [id]="item.id"></div>
          @if (!isLatestSales) {
            <div class="amount">{{ item.amount }}</div>
          }
        </div>
      }
    </div>
  </div>
}